const PRODUCTION_HOSTS = new Set(['sugargremlin.co.nz', 'www.sugargremlin.co.nz'])

export function isProductionSiteHostname(hostname: string) {
  return PRODUCTION_HOSTS.has(hostname.trim().toLowerCase())
}

export function stagingQaRuntimeAllowed(hostname: string) {
  return !isProductionSiteHostname(hostname)
}
